import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CapacityGranularity } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestPending: boolean;
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  adjustWorkload(request: Boundaries["adjustWorkload"]["request"]): void;
}

function useAdjustWorkload(
  resourceId: string,
  projectId: string,
  from: string,
  to: string,
  granularity: CapacityGranularity,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAdjustWorkloadRequestPending(
        resourceId,
        projectId,
        from,
        to,
        granularity,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAdjustWorkloadRequestSuccess(
        resourceId,
        projectId,
        from,
        to,
        granularity,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAdjustWorkloadRequestFailure(
        resourceId,
        projectId,
        from,
        to,
        granularity,
      ),
    ),
    adjustWorkload: core.adjustWorkload,
  };
}

export { useAdjustWorkload };
